import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import BlockAnalyticsTrendLine from './BlockAnalyticsTrendLine';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Section = styled.section`
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: ${props =>
    props.variant === 'primary'
      ? 'linear-gradient(to bottom, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02))'
      : 'rgba(255, 255, 255, 0.03)'};
  box-shadow: ${props =>
    props.variant === 'primary'
      ? 'inset 0 1px 0 rgba(255, 255, 255, 0.10)'
      : 'inset 0 1px 0 rgba(255, 255, 255, 0.06)'};
  padding: ${props => (props.noPadding ? '0' : '20px')};
  overflow: hidden;
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding: ${props => (props.inset ? '20px 20px 12px 20px' : '0')};
`;

const SectionTitle = styled.h2`
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  color: rgba(255, 255, 255, 0.95);
`;

const BookingAnalytics = ({ date }) => {
  const [aggregation, setAggregation] = useState('daily');

  const handleAggregationChange = useCallback(newAggregation => {
    setAggregation(newAggregation);
  }, []);

  const trendTitle =
    aggregation === 'daily' ? 'Trend by Day' : aggregation === 'weekly' ? 'Trend by Week' : 'Trend by Month';

  return (
    <Container>
      <Section noPadding>
        <SectionHeader inset>
          <SectionTitle>{trendTitle}</SectionTitle>
        </SectionHeader>
        <div style={{ padding: '0 20px' }}>
          <BlockAnalyticsTrendLine
            date={date || new Date()}
            height={'max(400px, calc(100vh - 560px))'}
            showBrush={true}
            defaultAggregation="daily"
            defaultDaysBack={30}
            onAggregationChange={handleAggregationChange}
          />
        </div>
      </Section>
    </Container>
  );
};

export default BookingAnalytics;
